import React from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../style/Blog.css';

const TutorialModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" animation={true} contentClassName="tutorial-modal-content">
      <div className="tutorial-modal-wrapper p-4">
        <div className="retro-window p-4 mb-0">
          <div className="window-dots">
            <span className="dot red" />
            <span className="dot yellow" />
            <span className="dot green" />
          </div>

          <h2 className="text-center mb-4">Getting Started with Post App</h2>
          <p className="fs-5 fst-italic mb-4">Just a few steps to start your blogging journey:</p>

          <ol className="text-start fs-5" style={{ paddingLeft: '2.5rem' }}>
            <li className="mb-2">Register a new account.</li><li className="mb-2">Log into your account.</li>
            <li className="mb-2">Click <strong>“+ Create New Post”</strong> to start writing.</li>
            <li className="mb-2">Explore posts and join the conversation by commenting.</li>
          </ol>

          <div className="text-center mt-4">
            <button className="retro-button small-btn me-3" onClick={onHide}>Got it!</button>
            <Link to="/register" className="retro-button small-btn">Register Now!</Link>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TutorialModal;
